// import Header from './Header.svelte';
import Product from './Product.svelte';

const productTools = new Product({
	target: document.getElementById("product-control"),
});

// const header = new Header({
// 	target: document.getElementById("header-count"),
// });
